import { getLocalDateString } from 'utils/date';
import { downloadBuffer } from 'utils/download';

export async function downloadExcel(data: Buffer): Promise<void> {
  await downloadBuffer(
    `ops-invoices-${getLocalDateString(new Date(), { accountTimezone: true })}.xlsx`,
    data,
  );
}
